import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';
import * as actionTypes from './actionTypes';
//----------------------------------------------------------------------------------------------------------------------
export const checkInformation = (additionalInformationIdentities)=>({
        type: actionTypes.CHECK_INFORMATION,
        [WAIT_FOR_ACTION]: actionTypes.CHECK_INFORMATION_SUCCESS,
        [ERROR_ACTION]: actionTypes.CHECK_INFORMATION_ERROR,
        payload: {
            additionalInformationIdentities
        }
    });
export const checkInformationSuccess = ({ information = null, informationTemplate = [], consentsTemplate = [], isNoMandatoryConsent = false, isNoMandatoryInformation = false } = {})=>({
        type: actionTypes.CHECK_INFORMATION_SUCCESS,
        payload: {
            information,
            informationTemplate,
            consentsTemplate,
            isNoMandatoryConsent,
            isNoMandatoryInformation
        }
    });
export const checkInformationError = (error)=>({
        type: actionTypes.CHECK_INFORMATION_ERROR,
        error: {
            error
        }
    });
//----------------------------------------------------------------------------------------------------------------------
export const setBasicInformationUpdate = (informationUpdate)=>({
        type: actionTypes.SET_BASIC_INFORMATION_UPDATE,
        payload: {
            informationUpdate
        }
    });
//----------------------------------------------------------------------------------------------------------------------
export const fetchConsentsTemplate = (countryCode)=>({
        type: actionTypes.FETCH_CONSENTS_TEMPLATE,
        payload: {
            countryCode
        }
    });
export const fetchConsentsTemplateSuccess = (consentsTemplate)=>({
        type: actionTypes.FETCH_CONSENTS_TEMPLATE_SUCCESS,
        payload: {
            consentsTemplate
        }
    });
export const fetchConsentsTemplateError = (error)=>({
        type: actionTypes.FETCH_CONSENTS_TEMPLATE_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const sendInformation = (information, successMessage = null)=>({
        type: actionTypes.SEND_INFORMATION,
        payload: {
            information
        },
        successMessage
    });
export const sendInformationSuccess = ({ information, informationTemplate, consentsTemplate, isNoMandatoryConsent, isNoMandatoryInformation })=>({
        type: actionTypes.SEND_INFORMATION_SUCCESS,
        payload: {
            information,
            informationTemplate,
            consentsTemplate,
            isNoMandatoryConsent,
            isNoMandatoryInformation
        }
    });
export const sendInformationError = (error)=>({
        type: actionTypes.SEND_INFORMATION_ERROR,
        error: {
            error
        }
    });
export const fetchProfileAvatar = (avatarSrc)=>({
        type: actionTypes.FETCH_PROFILE_AVATAR,
        [WAIT_FOR_ACTION]: actionTypes.FETCH_PROFILE_AVATAR_SUCCESS,
        [ERROR_ACTION]: actionTypes.FETCH_PROFILE_AVATAR_ERROR,
        payload: {
            avatarSrc
        }
    });
export const fetchProfileAvatarSuccess = (avatar)=>({
        type: actionTypes.FETCH_PROFILE_AVATAR_SUCCESS,
        payload: {
            avatar
        }
    });
export const fetchProfileAvatarError = (error)=>({
        type: actionTypes.FETCH_PROFILE_AVATAR_ERROR,
        error
    }); //----------------------------------------------------------------------------------------------------------------------
